module.exports = __webpack_public_path__ + "static/media/19ESCAP36.3059af80.jpg";